<template>
	<modal-box @close="close" :header="$t(`buttons.actions.${params.action}_parameters`)" :subHeader="$t('base.watch.biometric')" class="biometric-parameters-form">
		<spinner v-if="model.loading"/>
		<error-box v-else-if="model.error" :error="model.error"/>
		<form v-else @submit.prevent="validateAndSubmit">
			<input-text v-model="model.data.name" name="name" :placeholder="$t('labels.general.name')" rules="required"/>
			<input-float v-model="model.data.min" name="min" :placeholder="$t('labels.general.min')" step="0.01" rules="required" v-if="!isBloodPressureType"/>
			<input-float v-model="model.data.max" name="max" :placeholder="$t('labels.general.max')" step="0.01" rules="required" v-if="!isBloodPressureType"/>
			<input-float v-model="model.data.interval_min_start" name="interval_min_start" :placeholder="$t('labels.general.min_start')" step="0.01" rules="required" v-if="isBloodPressureType"/>
			<input-float v-model="model.data.interval_min_end"   name="interval_min_end"   :placeholder="$t('labels.general.min_end')"   step="0.01" rules="required" v-if="isBloodPressureType"/>
			<input-float v-model="model.data.interval_max_start" name="interval_max_start" :placeholder="$t('labels.general.max_start')" step="0.01" rules="required" v-if="isBloodPressureType"/>
			<input-float v-model="model.data.interval_max_end"   name="interval_max_end"   :placeholder="$t('labels.general.max_end')"   step="0.01" rules="required" v-if="isBloodPressureType"/>
			<input-select v-model="model.data.urgency_type" :options="options" name="urgency" :placeholder="$t('labels.general.urgency')" rules="required"/>
			<error-box v-if="form.error" :error="form.error"/>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="form.loading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
	</modal-box>
</template>

<script>
import Readings from '@/utils/readings'
import ApiObject from '@/classes/api/ApiObject'
import Parameters from '@/classes/Parameters'
export default {
	props: [
		'user_uid',
		'watch_id',
		'params'
	],
	data () {
		return {
			name: 'watch biometric parameters form',
			model: new ApiObject(),
			form: {
				loading: false,
				error: ''
			},
			options: [
				{ value: 1, text: 'Min' },
				{ value: 2, text: 'Med' },
				{ value: 3, text: 'Max' },
			]
		}
	},
	computed: {
		isBloodPressureType () {
			return this.params.reading_type_id == Readings.TYPE_BLOOD_PRESSURE
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.submit()
				})
		},
		submit () {
			switch (this.params.action) {
				case 'add':
					this.addParams()
					break
				case 'edit':
					this.editParams()
					break
				default:
					this.$log.warn(this.name, 'action not set')()
			}
		},
		close (reload = false) {
			this.$emit('close', { reload })
		},
		getParams () {
			this.model.loading = true
			this.$api.parameters.get(this, this.user_uid, this.watch_id, this.params.reading_type_id, this.params.id)
				.then(response => {
					this.$log.info(this.name, 'parameters.get OK', response)()
					this.model.data = new Parameters(response.body)
				}).catch(error => {
					this.$log.error(this.name, 'parameters.get ERROR', error)()
					this.model.error = error
				}).finally(() => {
					this.model.loading = false
				})
		},
		addParams () {
			this.form.loading = true
			this.$api.parameters.add(this, this.user_uid, this.watch_id, this.params.reading_type_id, this.model.data)
				.then(response => {
					this.$log.info(this.name, 'parameters.add OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error(this.name, 'parameters.add ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		},
		editParams () {
			this.form.loading = true
			this.$api.parameters.edit(this, this.user_uid, this.watch_id, this.params.reading_type_id, this.model.data)
				.then(response => {
					this.$log.info(this.name, 'parameters.edit OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error(this.name, 'parameters.edit ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		}
	},
	created () {
		switch (this.params.action) {
			case 'add':
				this.model.data = new Parameters()
				break
			case 'edit':
				this.getParams()
				break
			default:
				this.$log.warn(this.name, 'action not set')()
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/biometric/ParametersForm.vue